<template>
  <div class="mt-4">
    <div class="row mb-4">
      <div :class="simulationId ? 'col-md-9' : 'col-md-12'">
        <b-card class="mb-4 shadow-sm">
          <b-form v-unsave-detector @submit.stop.prevent="onSubmit">
            <div class="row">
              <div class="col-md-4">
                <b-form-group
                  :invalid-feedback="form.name.invalidFeedback"
                  :label="$t('simulation.Name')"
                  :state="form.name.state"
                  class="medium-label mb-4"
                  label-for="name-input">
                  <b-form-input
                    id="name-input"
                    v-model="form.name.value"
                    :state="form.name.state"
                    maxlength="250"
                    required
                    tabindex="1"
                    type="text"
                    v-on:change="emitChangeValue">
                  </b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <AutocompleteField
                  :input-class="'medium-label mb-4'"
                  :input-id="'type-input'"
                  :input-label="$t('Dossier')"
                  :items="dossiers"
                  :required=true
                  :search-input="dossier"
                  @elementValueChanged="getSelectedValue">
                </AutocompleteField>
              </div>
              <div class="col-md-4">
                <b-form-group
                  :invalid-feedback="form.prixAchat.invalidFeedback"
                  :label="$t('simulation.PrixAchat')"
                  :state="form.prixAchat.state"
                  class="medium-label mb-4"
                  label-for="prixAchat-input">
                  <b-input-group>
                    <b-form-input
                      id="prixAchat-input"
                      v-model="form.prixAchat.value"
                      v-disable-scroll
                      :state="form.prixAchat.state"
                      min="0"
                      required
                      step="any"
                      tabindex="2"
                      type="number"
                      v-on:change="emitChangeValue"
                      v-on:input="updateValues('prixAchat');">
                    </b-form-input>
                    <b-input-group-append>€</b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </div>

              <div class="col-md-6">
                <b-form-group
                  :invalid-feedback="form.typesComAgences.invalidFeedback"
                  :label="$t('simulation.commissions.agences')"
                  :state="form.typesComAgences.state"
                  class="medium-label mb-4"
                  label-for="comAgence-input">
                  <b-form-select
                    id="comAgence-input"
                    v-model="form.typesComAgences.value"
                    :state="form.typesComAgences.state"
                    required
                    tabindex="3"
                    v-on:change="emitChangeValue"
                    v-on:input="updateValues('typeCom')">
                    <option v-for="option in typesComAgences" :value="option.value">
                      {{ $t(option.text) }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group
                  :invalid-feedback="form.commissions.invalidFeedback"
                  :label="$t('simulation.Commissions')"
                  :state="form.commissions.state"
                  class="medium-label mb-4"
                  label-for="commissions-input">
                  <b-input-group>
                    <b-form-input
                      id="commissions-input"
                      v-model="form.commissions.value"
                      v-disable-scroll
                      :disabled="this.disableCommission"
                      :state="form.commissions.state"
                      min="0"
                      step="any"
                      tabindex="4"
                      type="number"
                      v-on:change="emitChangeValue"
                      v-on:input="updateValues('commissions')">
                    </b-form-input>
                    <b-input-group-append>€</b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </div>

              <div class="col-md-6">
                <b-form-group
                  :invalid-feedback="form.fraisNotaire.invalidFeedback"
                  :label="$t('simulation.FraisNotaire')"
                  :state="form.fraisNotaire.state"
                  class="medium-label mb-4"
                  label-for="fraisNotaire-input">

                  <div class="row">
                    <div class="col-md-4">
                      <b-input-group>
                        <b-form-input
                          id="pourcentage-input"
                          v-model="form.pourcentage.value"
                          v-disable-scroll
                          max="100"
                          min="0"
                          required
                          step="0.01"
                          tabindex="5"
                          type="number"
                          v-on:change="emitChangeValue"
                          v-on:input="updateValues('pourcentage')">
                        </b-form-input>
                        <b-input-group-append>%</b-input-group-append>
                      </b-input-group>
                    </div>
                    <div class="col-md-8">
                      <b-input-group>
                        <b-form-input
                          id="fraisNotaire-input"
                          v-model="form.fraisNotaire.value"
                          v-disable-scroll
                          :state="form.fraisNotaire.state"
                          min="0"
                          required
                          step="any"
                          tabindex="6"
                          type="number"
                          v-on:change="emitChangeValue"
                          v-on:input="updateValues('fraisNotaire')">
                        </b-form-input>
                        <b-input-group-append>€</b-input-group-append>
                      </b-input-group>
                    </div>
                  </div>
                </b-form-group>
              </div>

              <div class="col-md-6">
                <multi-file-field
                  :label="$t('Documents').toString()"
                  :new-files-list="newDocumentsList"
                  :old-files-list="oldDocumentsList"
                  @addFiles="addDocuments"
                  @didChangeValue="emitChangeValue"
                  @removeNewFile="removeNewDocument"
                  @removeOldFile="removeOldDocument"/>

              </div>
            </div>

            <div class="d-flex justify-content-end">
              <b-button type="submit" variant="primary">
                {{ $t('Save.and.Continue') }}
              </b-button>
            </div>
          </b-form>
        </b-card>
      </div>

      <div v-if="simulationId" class="col-md-3">
        <SimulationBilanCardPrice
          :prices="totalPrices">
        </SimulationBilanCardPrice>
      </div>

    </div>

  </div>

</template>

<script>

import api from '../../../services/api'
import MultiFileField from "../../../components/b122/editFields/MultiFileField";
import SimulationBilanCardPrice from "./components/SimulationBilanCardPrice.vue";
import OperationBilanCardPrice from "../../operationBilan/bilanCreateEditSteps/components/OperationBilanCardPrice.vue";
import AutocompleteField from "../../../components/b122/editFields/AutocompleteField.vue";

export default {

  name: "SimulationChargeFonciere",

  components: {
    AutocompleteField,
    OperationBilanCardPrice,
    MultiFileField,
    SimulationBilanCardPrice
  },

  props: {
    simulationId: {
      type: Number,
      default: null
    },
    urbanStudyId: {
      type: Number,
      default: null
    }
  },

  data: function () {
    return {
      dossier: null,
      typesComAgences: [],
      simulation: {},
      urbanStudy: {},
      dossiers: [],
      form: {
        name:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        prixAchat:
          {
            state: null,
            invalidFeedback: null,
            value: null,
          },
        pourcentage:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        fraisNotaire:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        commissions:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        typesComAgences:
          {
            state: null,
            invalidFeedback: null,
            value: null
          }
      },
      newDocumentsList: [],
      oldDocumentsList: [],
      documentsToRemove: [],
      disableCommission: false,
      acceptUpdate: false,
      isCollaborator: this.$store.getters.isCollaborator,
      nbSimulations: null,
      totalPrices: []
    }
  },


  emits: ['didContinue', 'didChangeValue'],

  async mounted() {
    await this.fetchData()
  },

  methods: {

    getSelectedValue(data) {
      this.dossier = data
    },

    async fetchData() {
      if (this.simulationId) {
        await this.fetchSimulation()
        this.setInitialValues()
        await this.getTotalOfBilan()
      } else if (this.urbanStudyId) {
        await this.fetchUrbanStudy()
      }
      await this.getTypesComAgences()
      await this.getDossiers()
      await this.fetchAllSimulations()
      this.acceptUpdate = true
    },

    async getDossiers() {
      await api
        .get(`/simulation/getAllDossiers`)
        .then(response => {
          this.dossiers = response.data
        })
    },


    async getTypesComAgences() {
      await api
        .get(`/simulation/getTypesComAgences`)
        .then(response => {
          this.typesComAgences = response.data
          if (!this.form.typesComAgences.value) {
            this.form.typesComAgences.value = this.typesComAgences[0].value
            if (this.form.typesComAgences.value === "AUCUNE_COMMISSION") {
              this.form.commissions.value = 0;
              this.disableCommission = true;
            }
          }
        })
    },

    async fetchSimulation() {
      await api
        .get(`/simulation/${this.simulationId}`)
        .then(response => {
          this.simulation = response.data
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'SimulationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    async fetchAllSimulations() {
      api
        .get('/simulation/getAllAuthorizedSimulations')
        .then(response => {
          this.nbSimulations = response.data.length
        })
    },

    async fetchUrbanStudy() {
      await api
        .get(`/urbanStudy/${this.urbanStudyId}`)
        .then(response => {
          this.urbanStudy = response.data
          this.form.name.value = this.urbanStudy.name
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'SimulationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    async getTotalOfBilan() {
      await api
        .get(`/simulation/getTotalOfBilan/${this.simulationId}`)
        .then(response => {
          this.totalPrices = response.data
        })
    },

    setInitialValues() {
      if (this.simulation != null) {
        this.form.name.value = this.simulation.name
        this.form.prixAchat.value = Number(this.simulation.prixAchat)
        this.form.typesComAgences.value = this.simulation.typeComAgence.value
        if (this.form.typesComAgences.value === "AUCUNE_COMMISSION") {
          this.disableCommission = true;
        }
        this.form.commissions.value = Number(this.simulation.commissions)
        this.form.fraisNotaire.value = Number(this.simulation.fraisNotaire)
        this.form.pourcentage.value = this.form.typesComAgences.value === "CHARGES_VENDEURS" ? ((Number(this.form.fraisNotaire.value) * 100) / (Number(this.form.prixAchat.value) + Number(this.form.commissions.value))).toFixed(2) : ((Number(this.form.fraisNotaire.value) * 100) / Number(this.form.prixAchat.value)).toFixed(2);
        this.oldDocumentsList = this.simulation.documents
        this.dossier = this.simulation.dossier
      }
    },

    async emitChangeValue() {
      this.$emit('didChangeValue')
    },

    updateValues(modified) {
      if (this.acceptUpdate) {
        switch (modified) {
          case 'prixAchat':
            if (this.form.pourcentage.value && this.form.prixAchat.value && this.form.prixAchat.value > 0) {
              this.form.fraisNotaire.value = this.form.typesComAgences.value === "CHARGES_VENDEURS" ? ((Number(this.form.prixAchat.value) + Number(this.form.commissions.value)) * (Number(this.form.pourcentage.value) / 100)).toFixed(2) : (Number(this.form.prixAchat.value) * (Number(this.form.pourcentage.value) / 100)).toFixed(2);
            } else {
              this.form.fraisNotaire.value = 0;
            }
            break;
          case 'typeCom':
            if (this.form.typesComAgences.value === "AUCUNE_COMMISSION") {
              this.disableCommission = true;
              this.form.commissions.value = 0;
            } else {
              this.disableCommission = false;
            }

            if (this.form.prixAchat.value && this.form.pourcentage.value && this.form.prixAchat.value > 0) {
              if (this.form.typesComAgences.value === "CHARGES_VENDEURS") {
                this.form.fraisNotaire.value = ((Number(this.form.prixAchat.value) + Number(this.form.commissions.value)) * (Number(this.form.pourcentage.value) / 100)).toFixed(2);
              } else {
                this.form.fraisNotaire.value = (Number(this.form.prixAchat.value) * (Number(this.form.pourcentage.value) / 100)).toFixed(2);
              }
            } else {
              this.form.fraisNotaire.value = 0;
            }
            break;
          case 'commissions':
            if (this.form.pourcentage.value && this.form.prixAchat.value && this.form.prixAchat.value > 0) {
              if (this.form.typesComAgences.value === "CHARGES_VENDEURS") {
                this.form.fraisNotaire.value = ((Number(this.form.prixAchat.value) + Number(this.form.commissions.value)) * (Number(this.form.pourcentage.value) / 100)).toFixed(2);
              } else {
                this.form.fraisNotaire.value = (Number(this.form.prixAchat.value) * (Number(this.form.pourcentage.value) / 100)).toFixed(2);
              }
            } else {
              this.form.fraisNotaire.value = 0;
            }
            break;
          case 'pourcentage':
            if (this.form.pourcentage.value && this.form.prixAchat.value) {
              this.form.fraisNotaire.value = this.form.typesComAgences.value === "CHARGES_VENDEURS" ? ((Number(this.form.commissions.value) + Number(this.form.prixAchat.value)) * (Number(this.form.pourcentage.value) / 100)).toFixed(2) : (Number(this.form.prixAchat.value) * (Number(this.form.pourcentage.value) / 100)).toFixed(2);
            }
            break;
          case 'fraisNotaire':
            if (this.form.fraisNotaire.value && this.form.prixAchat.value && this.form.prixAchat.value > 0) {
              this.form.pourcentage.value = this.form.typesComAgences.value === "CHARGES_VENDEURS" ? ((Number(this.form.fraisNotaire.value) * 100) / (Number(this.form.prixAchat.value) + Number(this.form.commissions.value))).toFixed(2) : ((Number(this.form.fraisNotaire.value) * 100) / Number(this.form.prixAchat.value)).toFixed(2);
            }
            break;
          default:
            break;
        }
      }
    },

    addDocuments(files) {
      files.forEach(file => {
        this.newDocumentsList.push(file)
      })
    },

    removeNewDocument(file) {
      this.newDocumentsList.splice(this.newDocumentsList.indexOf(file), 1)
    },

    removeOldDocument(file) {
      this.oldDocumentsList.splice(this.oldDocumentsList.indexOf(file), 1)
      this.documentsToRemove.push(file)
    },

    onSubmit() {

      let data = new FormData()
      data.append('dossier', this.dossier)
      data.append('urbanStudyId', this.urbanStudyId)
      data.append('name', this.form.name.value)
      data.append('prixAchat', this.form.prixAchat.value)
      data.append('fraisNotaire', this.form.fraisNotaire.value)
      if (this.form.commissions.value != null) {
        data.append('commissions', this.disableCommission ? 0.0 : this.form.commissions.value)
      }
      data.append('TypeComAgences', this.form.typesComAgences.value)
      this.newDocumentsList.forEach(file => {
        data.append('documents', file)
      })
      this.documentsToRemove.forEach(file => {
        data.append('documentsToRemove', file.id)
      })

      let url = 'simulation'
      if (this.simulation.id) {
        url = '/simulation/' + this.simulation.id
      }

      api({
        method: 'POST',
        url: url,
        data: data
      })
        .then((response) => {
          this.$emit('didContinue', response.data.id)
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'SimulationIndex',
              params: {
                message: error.response.data.message
              }
            })
          } else if (error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
          }
        })
    },

    removeInvalidFeedback(field) {
      this.form[field]['state'] = null
    },

  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/simulation/createEditSteps/SimulationChargeFonciere.vue